import axios from "axios";
import { MessageBox, Message } from "element-ui";

// 创建axios实例
const service = axios.create({
  baseURL: "https://admin.henlv.net/api/", // api的base_url
  // baseURL: "https://hengshuaitest.edochxun.com/api/", // api的base_url
  timeout: 5000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers["token"] = localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    // 做一些请求错误
    console.log("做一些请求错误", error); // for debug
    return Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  (response) => {
    const res = response.data;
    // console.log("123", response);
    // 如果code不为200，则报错
    if (res.code !== 1) {
      // Message({
      //   message: res.message || "Error",
      //   type: "error",
      //   duration: 5 * 1000,
      // });

      if (res.code === 0) {
        Message.error(res.msg);
      }

      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error.response.status); // for debug
    if (error.response.status === 401) {
      // Message.error("请重新登录");
      localStorage.removeItem("token");
      localStorage.removeItem("userinfo");
    } else {
      Message({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    }
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request/request.js